// Браузерлердің көбінде kk-KZ ай атаулары жоқ ("m05" шығады), сондықтан қолмен
const KK_MONTHS = [
  "қаңтар",
  "ақпан",
  "наурыз",
  "сәуір",
  "мамыр",
  "маусым",
  "шілде",
  "тамыз",
  "қыркүйек",
  "қазан",
  "қараша",
  "желтоқсан",
];

export const formatDate = (createdAt) => {
  const date = new Date(createdAt);
  const day = date.getDate();
  const month = KK_MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year} ж.`;
};
